/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MessageEdit_lists$ref = any;
type MessageEdit_message$ref = any;
export type MessageEditQueryVariables = {|
  messageId: string
|};
export type MessageEditQueryResponse = {|
  +message: ?{|
    +$fragmentRefs: MessageEdit_message$ref
  |},
  +lists: ?{|
    +$fragmentRefs: MessageEdit_lists$ref
  |},
|};
export type MessageEditQuery = {|
  variables: MessageEditQueryVariables,
  response: MessageEditQueryResponse,
|};
*/


/*
query MessageEditQuery(
  $messageId: ID!
) {
  message: node(id: $messageId) {
    __typename
    ...MessageEdit_message
    id
  }
  lists {
    ...MessageEdit_lists
    id
  }
}

fragment MessageDelete_lists on Lists {
  id
}

fragment MessageDelete_message on Message {
  id
}

fragment MessageEdit_lists on Lists {
  ...MessageDelete_lists
}

fragment MessageEdit_message on Message {
  id
  title
  body
  endDate
  externalUrl
  hasMessageable
  backgroundImageUrl
  messageableType
  messageableId
  mixpanelWebhook
  pushNotificationText
  callToAction
  messageDisplay {
    title
    body
    endDate
    externalUrl
    backgroundImageUrl
    pushNotificationText
    callToAction
    id
  }
  ...MessageDelete_message
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "messageId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "messageId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundImageUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pushNotificationText",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "callToAction",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageEditQuery",
    "selections": [
      {
        "alias": "message",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MessageEdit_message"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MessageEdit_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessageEditQuery",
    "selections": [
      {
        "alias": "message",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasMessageable",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "messageableType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "messageableId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mixpanelWebhook",
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageDisplay",
                "kind": "LinkedField",
                "name": "messageDisplay",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Message"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "MessageEditQuery",
    "operationKind": "query",
    "text": "query MessageEditQuery(\n  $messageId: ID!\n) {\n  message: node(id: $messageId) {\n    __typename\n    ...MessageEdit_message\n    id\n  }\n  lists {\n    ...MessageEdit_lists\n    id\n  }\n}\n\nfragment MessageDelete_lists on Lists {\n  id\n}\n\nfragment MessageDelete_message on Message {\n  id\n}\n\nfragment MessageEdit_lists on Lists {\n  ...MessageDelete_lists\n}\n\nfragment MessageEdit_message on Message {\n  id\n  title\n  body\n  endDate\n  externalUrl\n  hasMessageable\n  backgroundImageUrl\n  messageableType\n  messageableId\n  mixpanelWebhook\n  pushNotificationText\n  callToAction\n  messageDisplay {\n    title\n    body\n    endDate\n    externalUrl\n    backgroundImageUrl\n    pushNotificationText\n    callToAction\n    id\n  }\n  ...MessageDelete_message\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '52b1645161f74527d86873e974b660bc';

module.exports = node;
